module.exports = "/images/house-key.svg?79164767e8d666917ed685f22b9b4643";